import { Component } from '@angular/core';
import { AuthService } from '../../auth.service';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Declare grecaptcha as a global variable
declare const grecaptcha: any;

@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.css'
})
export class SignupComponent {
  // Add your component logic here
  captchaToken = '';
  captchaScore = 0;
  captchaResponse:any = '';
  captchaError:any = '';

  siteKeyEnterprise = '6Le6KCgrAAAAAFTVUF2w0YKyz9CJfeAtEPEbsHI3';
  useEnterprise = true;

  constructor(private authService: AuthService, private fb: FormBuilder) {
    // Initialization code
    // const key = this.useEnterprise ? this.siteKeyEnterprise : this.siteKeyV3;
    this.authService.loadRecaptchaScript(this.useEnterprise).catch(console.error);
  }
  signupForm = this.fb.group({
    fname: ['test', Validators.required],
    lname: ['poc', Validators.required],
    email: ['poc@yopmail.com', [Validators.required, Validators.email]],
    phone: ['9999999999', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    password: ['abs123@A', [Validators.required, Validators.minLength(6)]],
    ack: [true, Validators.requiredTrue],
  });

  getCaptchaToken(): void {
    grecaptcha.ready(() => {
      grecaptcha.execute(this.siteKeyEnterprise, { action: 'signup' }).then(
        (token: string) => {
          this.captchaToken = token; // Store the token
          console.log('Captcha token:', token);
          this.handleCaptchaResponse(); // Handle the captcha response
          // this.submitForm(token); // Pass token to API
        },
        (error: any) => {
          this.handleCaptchaError(error); // Handle captcha errors
        }
      );
    });
  }
  handleCaptchaResponse(): void {
    console.log('Captcha token received:', this.captchaToken);
    this.captchaError = '';
    this.authService.authenticate(this.signupForm.value, this.captchaToken).subscribe({
      next: (res:any) => {
        console.log('Auth Success:', res);
        this.captchaResponse = res;
        // this.captchaScore = res.score || 0; // Assuming the response contains a score

      },
      error: (err) => {
        console.error('Auth Failed:', err);
        this.captchaResponse = '';
        this.captchaError = err;
      }
    });
  }

  handleCaptchaError(error: any): void {
    console.error('Captcha error:', error);
    this.captchaError = error;
    this.captchaToken = '';
    this.captchaScore = 0;
    this.captchaResponse = '';
    // Additional logic to handle captcha errors
  }
  // Example method
  submitForm() {
    // Handle form submission
    if (this.signupForm.valid) {
      console.log('Form Data:', this.signupForm.value);
      // Handle CAPTCHA + API call here
      // this.getCaptchaToken();
      this.runCaptcha()
    } else {
      this.signupForm.markAllAsTouched();
    }
  }
  submitReferralWithoutToken() {
    this.authService.authenticate(this.signupForm.value, '').subscribe({
      next: (res:any) => {
        console.log('Auth Success:', res);
        this.captchaResponse = res;
        // this.captchaScore = res.score || 0; // Assuming the response contains a score

      },
      error: (err) => {
        console.error('Auth Failed:', err);
        this.captchaError = err;
        this.captchaToken = '';
        this.captchaResponse = '';
      }
    });
  }
  runCaptcha() {

    this.authService
      .execute(this.useEnterprise, 'signup')
      .then((token) => {
          this.captchaToken = token; // Store the token
          console.log('Captcha token:', token);
          this.handleCaptchaResponse();
        // Send token to your backend for verification
      })
      .catch(console.error);
  }

}
